import React, { ReactNode, } from "react";

export type GrowProps = {
  in?: boolean;
  children: ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

export default function Grow({
  in: inProp = false,
  children,
  style,
  className = ""
}: GrowProps): JSX.Element {
  return (
    <div
      className={`transition-all duration-300 ease-in-out ${
        inProp
          ? "scale-100 opacity-100"
          : "pointer-events-none scale-90 opacity-0"
      } ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}